// extracted by mini-css-extract-plugin
module.exports = {"menu":"ShoppingCartMobileMenu_menu__vwoyR","container":"ShoppingCartMobileMenu_container__tRCgQ"};